import axios from "axios";
import { store } from "../redux/store";
import { clearError, logout } from "../features/user/authSlice"; // Import your clearError action
import { clearPharmacyList } from "../features/pharmacy/pharmacySlice";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
});

// Request interceptor to attach token
api.interceptors.request.use(
  (config) => {
    const state = store.getState();
    const token = state.auth?.token; // Use token from auth state (instead of state.auth?.user?.token)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor to handle token expiration
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname !== '/login') {
      // Dispatch logout and clearError action on 401 (unauthorized)
      store.dispatch(clearError()); // Dispatch the clearError action to reset error state
      store.dispatch(clearPharmacyList());
      store.dispatch(logout()); // Optionally log out the user
      window.location.href = "/login"; // Redirect to the login page
    }
    return Promise.reject(error);
  }
);

export default api;
